import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ModalController } from '@ionic/angular/standalone';

import { IconNames } from '../../../../shared';
import { ButtonComponent } from '../../../buttons';
import { SvgIconComponent } from '../../../icons';

export enum AlertModalContentComponentRoles {
    Confirm = 'confirm',
    Cancel = 'cancel'
}

@Component({
    selector: 'lib-alert-modal-content',
    standalone: true,
    imports: [CommonModule, ButtonComponent, SvgIconComponent],
    templateUrl: './alert-modal-content.component.html',
    styleUrl: './alert-modal-content.component.scss'
})
export class AlertModalContentComponent {
    @Input() headerText: string = '';
    @Input() headerTextColor: string | undefined = undefined;
    @Input() headerIcon: IconNames | undefined = undefined;
    @Input() headerIconSize: number = 23;
    @Input() headerIconColor: string = 'white';
    @Input() headerIconBackgroundColor: string = 'var(--ion-color-red)';
    @Input() headerIconBackground: string = 'var(--ion-color-red-faded)';
    @Input() message: string = '';
    @Input() confirmButtonLabel: string = 'Confirm';
    @Input() cancelButtonLabel: string = 'Cancel';

    @Output() confirmClick: EventEmitter<{ success: boolean }> = new EventEmitter();
    @Output() cancelClick: EventEmitter<{ success: boolean }> = new EventEmitter();

    constructor(private modalCtrl: ModalController) {}

    confirm() {
        this.confirmClick.emit();
        this.modalCtrl.dismiss({ success: true }, AlertModalContentComponentRoles.Confirm);
    }

    cancel() {
        this.cancelClick.emit();
        this.modalCtrl.dismiss({ success: false }, AlertModalContentComponentRoles.Cancel);
    }
}
